import { render, staticRenderFns } from "./program-list-duration.vue?vue&type=template&id=4596b954&"
import script from "./program-list-duration.vue?vue&type=script&lang=js&"
export * from "./program-list-duration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports